import React from "react";
import ReactDOM from "react-dom";
import {
  Trail,
  Keyframes,
  animated,
  config,
  Transition,
} from "react-spring/renderprops";
import "./App.css";

// words images
import amasa from "../../assets/images/words/amasa.png";
import ala from "../../assets/images/words/ala.png";
import árbol from "../../assets/images/words/arbol.png";
import avión from "../../assets/images/words/avión.png";
import cama from "../../assets/images/words/cama.png";
import come_torta from "../../assets/images/words/come_torta.png";
import corazón from "../../assets/images/words/corazón.png";
import hombre from "../../assets/images/words/hombre.png";
import lápiz from "../../assets/images/words/lápiz.png";
import lee from "../../assets/images/words/lee.png";
import león from "../../assets/images/words/león.png";
import lila from "../../assets/images/words/lila.png";
import lima from "../../assets/images/words/lima.png";
import limón from "../../assets/images/words/limón.png";
import lobo from "../../assets/images/words/lobo.png";
import loma from "../../assets/images/words/loma.png";
import loro from "../../assets/images/words/loro.png";
import luna from "../../assets/images/words/luna.png";
import mamá from "../../assets/images/words/mamá.png";
import manos from "../../assets/images/words/manos.png";
import melón from "../../assets/images/words/melón.png";
import manzana from "../../assets/images/words/manzana.png";
import mesa from "../../assets/images/words/mesa.png";
import miel from "../../assets/images/words/miel.png";
import mimo from "../../assets/images/words/mimo.png";
import momia from "../../assets/images/words/momia.png";
import mono from "../../assets/images/words/mono.png";
import moto from "../../assets/images/words/moto.png";
import muela from "../../assets/images/words/muela.png";
import mula from "../../assets/images/words/mula.png";
import ola from "../../assets/images/words/ola.png";
import oso from "../../assets/images/words/oso.png";
import patinar from "../../assets/images/words/patinar.png";
import perro from "../../assets/images/words/perro.png";
import piña from "../../assets/images/words/piña.png";
import rosa from "../../assets/images/words/rosa.png";
import sol from "../../assets/images/words/sol.png";
import sala from "../../assets/images/words/sala.png";
import sal from "../../assets/images/words/sal.png";  
import seis from "../../assets/images/words/seis.png";
import suma from "../../assets/images/words/suma.png";  
import tortuga from "../../assets/images/words/tortuga.png";
import isla from "../../assets/images/words/isla.png";
import bicicleta from "../../assets/images/words/bicicleta.png";
import chancho from "../../assets/images/words/chancho.png";
import dado from "../../assets/images/words/dado.png";
import guitarra from "../../assets/images/words/guitarra.png";
import jirafa from "../../assets/images/words/jirafa.png";
import pez from "../../assets/images/words/pez.png";
import torta from "../../assets/images/words/torta.png";
import queque from "../../assets/images/words/queque.png";


const dict_words = {
  amasa: amasa,
  isla: isla,
  ala: ala,
  árbol: árbol,
  avión: avión,
  bicicleta: bicicleta,
  cama: cama,
  chancho: chancho,
  come_torta: come_torta,
  corazón: corazón,
  dado: dado,
  guitarra: guitarra,
  hombre: hombre,
  jirafa: jirafa,
  lápiz: lápiz,
  lee: lee,
  león: león,
  lila: lila,
  lima: lima,
  limón: limón,
  lobo: lobo,
  loma: loma,
  loro: loro,
  luna: luna,
  mamá: mamá,
  manos: manos,
  melón: melón,
  mesa: mesa,
  miel: miel,
  mimo: mimo,
  momia: momia,
  manzana: manzana,
  mono: mono,
  moto: moto,
  mula: mula,
  muela: muela,
  ola: ola,
  oso: oso,
  patinar: patinar,
  perro: perro,
  pez: pez,
  piña: piña,
  rosa: rosa,
  sol: sol,
  seis: seis,
  sal: sal,
  sala: sala,
  suma: suma,
  torta: torta,
  tortuga: tortuga,
  queque: queque,
};

const defaultStyles = {
  overflow: "hidden",
  position: "absolute",
  color: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // fontSize: "2em",
  fontFamily: "'Kanit', sans-serif",
  textTransform: "uppercase",
  cursor: "pointer",
  zIndex: 1000000,
};

export default class Frame extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      frame: this.props.frame,
      position: this.props.id,
      point: 0,
      imageWord: "",
    };
    this.changeValue = this.changeValue.bind(this);
    this.incrementPoint = this.incrementPoint.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidUpdate() {
    if (isNaN(this.state.frame)) {
      this.setState({ imageWord: dict_words[this.state.frame] });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.refresh);
  }

  changeValue(value) {
    this.setState({ frame: value });
  }

  incrementPoint() {
    let point = this.state.frame;
    point = point + 1;
    this.setState({ frame: point });
  }

  refresh() {
    if (typeof this.state.frame === "number") {
      let point = this.state.frame;
      point = point + 1;
      this.setState({ frame: point });
      this.setState({ frame: point - 1 });
    } else {
      let currentFrame = this.state.frame;
      this.setState({ frame: "" });
      this.setState({ frame: currentFrame });
    }
  }

  render() {
    let position = "";
    let width = 9.66;
    let height = (window.innerHeight * 17.4) / 100;
    let top = 0;
    if (
      (window.innerWidth > 480) &
      (window.innerWidth / window.innerHeight > 1)
    ) {
      top = "71.4%";
      position = "33.55%";
      if (this.props.id === 1) {
        position = "45.15%";
      } else if (this.props.id === 2) {
        position = "56.8%";
      } else if (this.props.id === 4) {
        width = 8.35;
        height = (window.innerHeight * 15) / 100;
        position = "72.35%";
        top = "3.9%";
      }
    } else {
      width = 24.5;
      height = (window.innerHeight * 13.5) / 100;
      top = "78.5%";
      position = "9.5%";
      if (this.props.id === 1) {
        position = "37.8%";
      } else if (this.props.id === 2) {
        position = "66.6%";
      } else if (this.props.id === 4) {
        position = "71.9%";
        width = 24.7;
        height = (window.innerHeight * 13.8) / 100;
        top = "3.50%";
      }
    }
    return (
      <Transition
        items={this.state.frame}
        // initial={null}
        from={{
          overflow: "hidden",
          height: height,
          opacity: 1,
          background: "white",
        }}
        enter={{
          width: width + "%",
          height: height,
          opacity: 1,
          borderRadius: "50%",
          border: "3px solid black",
        }}
        leave={{
          height: height,
          opacity: 1,
          display: "none",
        }}
        trail={200}
      >
        {(item) => (styles) => (
          <animated.div
            style={{ ...defaultStyles, ...styles, left: position, top: top }}
          >
            {this.state.imageWord !== "" ? (
              <div>
                <img
                  src={this.state.imageWord}
                  className="words-image"
                  alt="background"
                />
              </div>
            ) : (
              <div>
                <strong style={{ fontSize: "32px" }}>{item}</strong>
              </div>
            )}
          </animated.div>
        )}
      </Transition>
    );
  }
}
